import { Link } from "react-router-dom";
import { getMoviesByType } from "@/utils/movieUtils";

const entries = [
  {
    type: "movie",
    name: "电影频道",
    desc: "院线佳作 · 经典回顾 · 治愈爱情",
    icon: "ri-film-line",
    bg: "bg-primary-500",
    text: "text-background-50",
  },
  {
    type: "series",
    name: "电视剧频道",
    desc: "热播日剧 · 悬疑推理 · 都市生活",
    icon: "ri-tv-2-line",
    bg: "bg-accent-500",
    text: "text-foreground-950",
  },
];

export default function CategoryEntry() {
  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-10 md:px-8 md:py-12">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:gap-6">
        {entries.map((entry) => {
          const count = getMoviesByType(entry.type).length;
          return (
            <Link
              key={entry.type}
              to={`/category/${entry.type}`}
              className={`group flex items-center gap-5 rounded-lg p-5 transition-transform duration-300 hover:-translate-y-1 md:p-7 ${entry.bg} ${entry.text}`}
            >
              <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-lg bg-background-50/20 md:h-16 md:w-16">
                <i className={`${entry.icon} text-3xl`} aria-hidden="true"></i>
              </span>
              <span className="flex-1">
                <span className="flex items-center gap-2 font-heading text-lg font-bold md:text-xl">
                  {entry.name}
                  <i
                    className="ri-arrow-right-line transition-transform group-hover:translate-x-1"
                    aria-hidden="true"
                  ></i>
                </span>
                <span className="mt-1 block text-sm opacity-90">{entry.desc}</span>
                <span className="mt-2 block text-xs opacity-80">
                  共 {count} 部作品
                </span>
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}